module.exports = __webpack_public_path__ + "static/media/renegades_anonymous.a5fcc38c.png";